import { HighlightSearchTerm } from "components/DesignSystem/HighlightText";
import { EmojiMatch } from "util/searchEmojis";
import { EmojiPopup } from "./EmojiSuggestion";
import { SuggestionListbox, SuggestionOption } from "./SuggestionListbox";

type EmojiSuggestionListProps = {
  popup: EmojiPopup;
};

type EmojiOptionProps = {
  emoji: EmojiMatch;
  query: string;
  isHighlighted: boolean;
  onSelect: (emoji: EmojiMatch) => void;
  onHighlight: (emoji: EmojiMatch) => void;
};

const EmojiOption = ({
  emoji,
  query,
  isHighlighted,
  onSelect,
  onHighlight,
}: EmojiOptionProps) => {
  const handleSelect = () => onSelect(emoji);
  const handleHighlight = () => onHighlight(emoji);

  return (
    <SuggestionOption
      label={`:${emoji.id}:`}
      isHighlighted={isHighlighted}
      onSelect={handleSelect}
      onHighlight={handleHighlight}
    >
      <span className="t-text-body-lg" aria-hidden>
        {emoji.native}
      </span>
      <span className="t-flex-1 t-truncate">
        :<HighlightSearchTerm text={emoji.id} searchTerm={query} />:
      </span>
      {isHighlighted && (
        <kbd className="t-rounded t-bg-neutral-10 t-px-1.5 t-font-sans t-text-body-sm t-text-text-60">
          Enter
        </kbd>
      )}
    </SuggestionOption>
  );
};

export const EmojiSuggestionList = ({ popup }: EmojiSuggestionListProps) => (
  <SuggestionListbox ariaLabel="Emoji suggestions" className="t-w-80">
    {popup.items.map((emoji, index) => (
      <EmojiOption
        key={emoji.id}
        emoji={emoji}
        query={popup.query}
        isHighlighted={index === popup.highlightedIndex}
        onSelect={popup.onSelect}
        onHighlight={popup.onHighlight}
      />
    ))}
  </SuggestionListbox>
);
